import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { commonToast, hitApi, setMyState, validations, useOutsideClick } from "./commonAction";
import { useGoogleLogin } from '@react-oauth/google';
import { useStore } from "../zustand/store";
import Cookies from "js-cookie";
import { useNavigate } from 'react-router-dom';
import appConfig from './../config/appConfig';
import { useSearchParams } from "react-router-dom";
import { OldSocialLogin as SocialLogin } from "react-social-login";
import { Mail, Lock, Eye, EyeOff, User, ArrowLeft, AlertCircle } from 'lucide-react';
import "./auth.css";

const Login = ({ pageTitle }) => {
    let store = useStore(state => state);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const formtype     = searchParams.get("formtype");
    const source       = searchParams.get("source");
    const affiliate_id = searchParams.get("affiliate_id");
    const utm_source   = searchParams.get("utm_source");
    const utm_medium   = searchParams.get("utm_medium");
    const utm_campaign = searchParams.get("utm_campaign");
    const utm_term     = searchParams.get("utm_term");
    const utm_content  = searchParams.get("utm_content");

    const [showPass, setShowPass]   = useState(false);
    const [rememberMe, setRememberMe] = useState(false);

    let [authType, setauthType] = useState(formtype === 'signup' ? 'createAccount' : 'login');

    let [state, setState] = useState({
        name: '',
        email: '',
        password: '',
        isRemember: true,
        isProcess: false,
        loginProcess: false,
        evalidated: false,
    });

    const firstInputRef = useRef(null);
    useEffect(() => {
        if (!rememberMe) {
            setState({ name: '', email: '', password: '', isRemember: true, isProcess: false, evalidated: false });
            clearForm();
        }
        if (firstInputRef.current) firstInputRef.current.focus();
    }, [authType]);

    let [sourcInfo, setSourcInfo] = useState({});

    useEffect(() => {
        (async () => {
            let utm = {};
            let updatedSourcInfo = { source: source || 'pixalab', ip: await getPublicIP() };
            let useSearchParams = JSON.parse(localStorage.getItem('useSearchParams'));
            setSourcInfo(updatedSourcInfo);
            if (utm_source) {
                utm = { affiliate_id, utm_source, utm_medium, utm_campaign, utm_term, utm_content, ...updatedSourcInfo };
            } else if (useSearchParams && useSearchParams?.utm_source) {
                utm = useSearchParams;
            } else {
                utm = updatedSourcInfo;
            }
            localStorage.setItem("useSearchParams", JSON.stringify(utm));
        })();
    }, []);

    const clearForm = () => {
        if (!rememberMe) {
            const passwordloginpass = document.getElementById('loginpass');
            const passwordsignupPassword = document.getElementById('signupPassword');
            if (passwordloginpass) passwordloginpass.value = '';
            if (passwordsignupPassword) passwordsignupPassword.value = '';
        }
    };

    const modalRef = useRef();
    useOutsideClick(modalRef, () => setMyState(setState, { evalidated: false }));

    let manageLogin = (resp, source) => {
        let authData = resp.data;
        let { token, role } = authData;
        Cookies.set('authToken', token, { expires: +process.env.REACT_APP_TOKEN_LIFE });
        store.updateStore("userData", { ...authData, source });
        localStorage.setItem("useSearchParams", JSON.stringify(sourcInfo));
        if (source) {
            try {
                const hasSource = store.appList?.[source];
                if (hasSource) { window.location.href = hasSource.url + token; }
                else { navigate(role === 'admin' ? "/admin" : '/dashboard'); }
            } catch (e) { console.log('error', e?.message); }
        } else {
            navigate(role === 'admin' ? "/admin" : '/dashboard');
        }
    };

    let createAnAccount = (e) => {
        e.preventDefault();
        let { name, email, password, isRemember } = state;
        if (!isRemember) { commonToast('error', 'Please check the box to accept our Terms and Conditions and Privacy Policy.'); return; }
        if (name.trim() && email && password) {
            let isValid = validations(email, 'email') && validations(password, 'password');
            if (isValid) {
                setMyState(setState, { isProcess: true });
                let useSearchParams = JSON.parse(localStorage.getItem('useSearchParams'));
                hitApi({ url: 'auth/signup', method: "POST", data: { name, email, password, client: 'pixalab', ...useSearchParams } }, (resp, err = null) => {
                    if (resp.status) setauthType('login');
                    setMyState(setState, { isProcess: false });
                    localStorage.setItem("useSearchParams", JSON.stringify(sourcInfo));
                });
            }
        } else {
            const emptyField = !name ? 'Name' : !email ? 'Email' : !password ? 'Password' : null;
            commonToast('error', `${emptyField} is required.`);
        }
    };

    useEffect(() => {
        const savedEmail = localStorage.getItem("remember_email");
        const savedPass  = localStorage.getItem("remember_password");
        const savedCheck = localStorage.getItem("remember_check") === "true";
        if (savedCheck) {
            setMyState(setState, { email: savedEmail, password: savedPass });
            setRememberMe(true);
        } else {
            setRememberMe(false);
        }
    }, []);

    async function getPublicIP() {
        const response = await fetch("https://ipinfo.io/ip?token=YOUR_TOKEN_HERE");
        const ip = await response.text();
        return ip.trim();
    }

    let loginMe = async (e) => {
        e.preventDefault();
        let { email, password } = state;
        if (email && password) {
            if (rememberMe) {
                localStorage.setItem("remember_email", email);
                localStorage.setItem("remember_password", password);
                localStorage.setItem("remember_check", "true");
            } else {
                localStorage.removeItem("remember_email");
                localStorage.removeItem("remember_password");
                localStorage.removeItem("remember_check");
            }
            setMyState(setState, { loginProcess: true });
            hitApi({ url: 'auth/login', method: "POST", data: { email, password, source, ip: await getPublicIP() } }, (resp, err = null) => {
                setMyState(setState, { loginProcess: false });
                if (!err && resp.data) manageLogin(resp, source);
            });
        } else {
            const emptyField = !email ? 'Email' : !password ? 'Password' : null;
            commonToast('error', `${emptyField} is required.`);
        }
    };

    let socialLogin = async (params) => {
        setMyState(setState, { isProcess: false });
        let useSearchParams = JSON.parse(localStorage.getItem('useSearchParams'));
        hitApi({ url: 'auth/social-auth', method: "POST", data: { ...params, ...useSearchParams } }, (resp, err = null) => {
            setMyState(setState, { isProcess: false });
            if (!err && resp.data) manageLogin(resp, source);
        });
    };

    const handleSocialLogin = (data) => socialLogin({ ...data });

    const loginWithGoogle = useGoogleLogin({
        onSuccess: async tokenResponse => {
            let { access_token = null } = tokenResponse;
            if (access_token) {
                fetch("https://www.googleapis.com/oauth2/v3/userinfo", { headers: { Authorization: `Bearer ${access_token}` } })
                    .then(r => r.json())
                    .then(result => {
                        socialLogin({
                            _profile: { email: result.email, firstName: result.given_name, lastName: result.family_name, name: result.name, profilePicURL: result.picture },
                            _provider: 'Google',
                            _token: { ...tokenResponse },
                        });
                    })
                    .catch(error => console.log('error', error));
            } else {
                console.log('Something went wrong.');
            }
        },
        flow: 'implicit',
    });

    let forgotPasswordHandle = (e) => {
        e.preventDefault();
        if (!state.email) { commonToast('error', 'Email is required.'); return; }
        let isValid = validations(state.email, 'email');
        if (isValid) {
            setMyState(setState, { isProcess: true });
            hitApi({ url: 'auth/forgot-password', method: "PATCH", data: { email: state.email } }, (resp, err = null) => {
                setMyState(setState, { isProcess: false });
                if (resp?.status) setauthType("login");
            });
        }
    };

    const checkemail = (e) => {
        let regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/;
        setMyState(setState, { evalidated: !regex.test(e.target.value) });
    };

    const verificationToken = searchParams.get("verificationToken");
    useEffect(() => {
        (async function () {
            if (verificationToken) {
                hitApi({ url: 'auth/email-verification', method: "POST", data: { token: verificationToken, ip: await getPublicIP() } }, (resp, err = null) => {
                    if (!err && resp.data) setTimeout(() => manageLogin(resp, source), 1000);
                });
            }
        })();
    }, [verificationToken]);

    /* ── Shared footer elements ── */
    const GoogleBtn = () => (
        <>
            <div className="pxl-auth-or">OR</div>
            <button className="pxl-auth-google-btn" onClick={() => loginWithGoogle()} disabled={state?.isProcess} type="button">
                <img src="/assets/images/google.png" alt="Google" />
                Continue With Google
            </button>
        </>
    );

    return (
        <div className="pxl-auth-wrap" ref={modalRef}>

            {/* Logo */}
            <div className="pxl-auth-logo">
                <img src={source ? `./assets/images/login/${source}_logo.png` : appConfig.appLogo} alt="PixaLab" />
            </div>

            {/* ── Sign in ─────────────────────────────────────────── */}
            {authType === 'login' && (
                <>
                    <form onSubmit={loginMe}>
                        <h2 className="pxl-auth-title">Sign in to your account</h2>
                        <p className="pxl-auth-sub">Enter your details below to continue</p>

                        <div className="pxl-auth-fields">
                            <div className="pxl-auth-field">
                                <div className="pxl-auth-input-wrap">
                                    <span className="pxl-auth-input-icon"><Mail size={16} strokeWidth={2} /></span>
                                    <input
                                        name="loginemail" id="loginemail"
                                        ref={firstInputRef}
                                        className="pxl-auth-input"
                                        value={state?.email}
                                        placeholder="Email address"
                                        onChange={(e) => { checkemail(e); setMyState(setState, { email: e.target.value }); }}
                                    />
                                </div>
                                {state.evalidated && (
                                    <div className="pxl-auth-email-error">
                                        <AlertCircle size={12} /> Please enter a valid email address.
                                    </div>
                                )}
                            </div>

                            <div className="pxl-auth-field">
                                <div className="pxl-auth-input-wrap">
                                    <span className="pxl-auth-input-icon"><Lock size={16} strokeWidth={2} /></span>
                                    <input
                                        name="loginpass" id="loginpass"
                                        className="pxl-auth-input"
                                        value={state?.password}
                                        type={showPass ? "text" : "password"}
                                        placeholder="Password"
                                        onClick={() => setMyState(setState, { evalidated: false })}
                                        onFocus={() => setMyState(setState, { evalidated: false })}
                                        onChange={(e) => setMyState(setState, { password: e.target.value, evalidated: false })}
                                    />
                                    <button type="button" className="pxl-auth-input-eye" onClick={() => setShowPass(!showPass)}>
                                        {showPass ? <EyeOff size={16} strokeWidth={2} /> : <Eye size={16} strokeWidth={2} />}
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="pxl-auth-row">
                            <label className="pxl-auth-remember">
                                <input type="checkbox" checked={rememberMe} onChange={(e) => setRememberMe(e.target.checked)} />
                                Remember Me
                            </label>
                            <button type="button" className="pxl-auth-forgot" onClick={() => setauthType("forgotPassword")}>
                                Forgot Password?
                            </button>
                        </div>

                        <button className="pxl-auth-btn" type="submit" disabled={state?.loginProcess}>
                            {state?.loginProcess ? "Signing in…" : "Sign in"}
                        </button>
                    </form>

                    <GoogleBtn />

                    <div className="pxl-auth-switch">
                        Don't have an account?
                        <button className="pxl-auth-switch-btn" onClick={() => setauthType("createAccount")}>Create Account</button>
                    </div>
                </>
            )}

            {/* ── Create account ──────────────────────────────────── */}
            {authType === 'createAccount' && (
                <>
                    <form onSubmit={createAnAccount}>
                        <h2 className="pxl-auth-title">Create your account</h2>
                        <p className="pxl-auth-sub">Fill in the details below to get started.</p>

                        <div className="pxl-auth-fields">
                            <div className="pxl-auth-field">
                                <div className="pxl-auth-input-wrap">
                                    <span className="pxl-auth-input-icon"><User size={16} strokeWidth={2} /></span>
                                    <input
                                        name="signupname" id="signupname"
                                        ref={firstInputRef}
                                        className="pxl-auth-input"
                                        value={state?.name}
                                        placeholder="Full name"
                                        onChange={(e) => setMyState(setState, { name: e.target.value })}
                                    />
                                </div>
                            </div>

                            <div className="pxl-auth-field">
                                <div className="pxl-auth-input-wrap">
                                    <span className="pxl-auth-input-icon"><Mail size={16} strokeWidth={2} /></span>
                                    <input
                                        className="pxl-auth-input"
                                        value={state?.email}
                                        placeholder="Email address"
                                        onChange={(e) => { checkemail(e); setMyState(setState, { email: e.target.value }); }}
                                    />
                                </div>
                                {state.evalidated && (
                                    <div className="pxl-auth-email-error">
                                        <AlertCircle size={12} /> Please enter a valid email address.
                                    </div>
                                )}
                            </div>

                            <div className="pxl-auth-field">
                                <div className="pxl-auth-input-wrap">
                                    <span className="pxl-auth-input-icon"><Lock size={16} strokeWidth={2} /></span>
                                    <input
                                        name="signupPassword" id="signupPassword"
                                        className="pxl-auth-input"
                                        type="password"
                                        placeholder="Password (min. 8 characters)"
                                        value={state?.password}
                                        onClick={() => setMyState(setState, { evalidated: false })}
                                        onFocus={() => setMyState(setState, { evalidated: false })}
                                        onChange={(e) => setMyState(setState, { password: e.target.value, evalidated: false })}
                                    />
                                </div>
                            </div>
                        </div>

                        <button className="pxl-auth-btn" type="submit" disabled={state?.isProcess} style={{ marginBottom: 20 }}>
                            {state?.isProcess ? "Creating account…" : "Create Account"}
                        </button>
                    </form>

                    <GoogleBtn />

                    <div className="pxl-auth-switch">
                        Already have an account?
                        <button className="pxl-auth-switch-btn" onClick={() => setauthType("login")}>Log in</button>
                    </div>
                </>
            )}

            {/* ── Forgot password ─────────────────────────────────── */}
            {authType === 'forgotPassword' && (
                <form onSubmit={forgotPasswordHandle}>
                    <h2 className="pxl-auth-title">Forgot your password?</h2>
                    <p className="pxl-auth-sub">Enter your registered email and we'll send you a reset link.</p>

                    <div className="pxl-auth-fields">
                        <div className="pxl-auth-field">
                            <div className="pxl-auth-input-wrap">
                                <span className="pxl-auth-input-icon"><Mail size={16} strokeWidth={2} /></span>
                                <input
                                    ref={firstInputRef}
                                    className="pxl-auth-input"
                                    type="email"
                                    placeholder="Email address"
                                    value={state?.email}
                                    onChange={(e) => setMyState(setState, { email: e.target.value })}
                                />
                            </div>
                        </div>
                    </div>

                    <button className="pxl-auth-btn" type="submit" disabled={state?.isProcess}>
                        {state?.isProcess ? "Sending…" : "Send Reset Link"}
                    </button>

                    <div className="pxl-auth-back">
                        <button type="button" className="pxl-auth-back-btn" onClick={() => setauthType("login")}>
                            <ArrowLeft size={14} strokeWidth={2} /> Back to Sign in
                        </button>
                    </div>
                </form>
            )}

            {/* Copyright */}
            <div className="pxl-auth-copyright">
                Copyright © {new Date().getFullYear()} PixaLab. All Rights Reserved
                <br />
                <Link to="/terms-conditions">Terms and Conditions</Link> | <Link to="/privacy-policy">Privacy Policy</Link>
            </div>
        </div>
    );
};

export default Login;
